/**
 * Include your custom JavaScript here.
 *
 * Theme hooks: 'variant:changed', 'product:added', 'cart:refresh' (dispatch on document.documentElement to
 * refresh the mini-cart) and 'cart:rerendered'.
 */

/*
 * Northbound 2026-10-20: free-delivery top-up.
 * When the basket is under the £100 free-delivery line, the cart drawer and cart page suggest a few cheap
 * items from the same club (socks, scarves, shorts) that would take it over the line, using the store's own
 * search. If nothing matching is found it links to socks & accessories instead. Nothing is added
 * automatically; each suggestion links to its product page.
 * The theme re-draws the cart drawer after page load without always firing an event, so a light observer
 * puts the suggestions back whenever the "Spend £x more" message is shown without them.
 */
(function () {
  var THRESHOLD = 10000; // free UK delivery from £100 (pence)
  var MAX_PRICE = 2500;  // only suggest items up to £25
  var cache = {};
  var running = false;
  var lastRun = 0;

  function money(p) { return '£' + (p / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function teamFrom(title) {
    var t = String(title || '').replace(/\s*\(.*$/, '').trim();
    var m = t.match(/^\d{4}(?:-\d{2,4})?\s+(.+?)\s+(Home|Away|Third|Fourth|Training|Goalkeeper|Pre-Match|Prematch|Anthem|Retro|Shirt|Jersey|Mini|Supporter|SUPPORTER|Authentic|Long|Cup|Rugby|Polo|Jacket|Hoodie|Tee|T-Shirt|Shorts|Socks|Kit|Fan|Special|Track|Street|Icon)\b/i);
    if (m) return m[1];
    m = t.match(/^(.+?)\s+\d{4}/);
    if (m) return m[1];
    return '';
  }

  function suggest(q) {
    if (cache[q]) return Promise.resolve(cache[q]);
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { var list = (j.resources && j.resources.results && j.resources.results.products) || []; cache[q] = list; return list; })
      .catch(function () { return []; });
  }

  // The drawer shows the message in an .alert; the cart page shows it under the "My cart" heading.
  function holders() {
    return Array.prototype.filter.call(document.querySelectorAll('.alert, .page__header .page__description'), function (el) {
      return /more for free UK delivery|more and get free/i.test(el.textContent || '');
    });
  }

  function missing() {
    return holders().some(function (h) {
      var n = h.nextElementSibling;
      return !(n && n.classList.contains('glade-topup'));
    });
  }

  function clear() {
    Array.prototype.forEach.call(document.querySelectorAll('.glade-topup'), function (el) { el.remove(); });
  }

  function styles() {
    if (document.getElementById('glade-topup-css')) return;
    var s = document.createElement('style');
    s.id = 'glade-topup-css';
    s.textContent = '.glade-topup{margin:10px 0 4px;text-align:left}.page__header .glade-topup{max-width:420px;margin:12px 0 0;align-self:flex-start;width:100%}.glade-topup__title{font-size:13px;font-weight:600;margin:0 0 8px}.glade-topup__list{display:grid;gap:8px}.glade-topup__item{align-items:center;background:#fff;border:1px solid rgba(15,28,63,.12);border-radius:4px;color:inherit;display:grid;gap:10px;grid-template-columns:44px 1fr auto;padding:6px 8px;text-decoration:none}.glade-topup__item img{border-radius:3px;height:44px;object-fit:cover;width:44px}.glade-topup__name{font-size:12px;line-height:1.3}.glade-topup__price{font-size:13px;font-weight:600;white-space:nowrap}.glade-topup__more{display:inline-block;font-size:12px;margin-top:8px;text-decoration:underline}';
    document.head.appendChild(s);
  }

  function render(list) {
    var html = '<div class="glade-topup">';
    if (list.length) {
      html += '<p class="glade-topup__title">Add one of these to get free UK delivery</p><div class="glade-topup__list">';
      list.forEach(function (p) {
        var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=100" alt="" loading="lazy">' : '<span></span>';
        html += '<a class="glade-topup__item" href="' + esc(String(p.url).split('?')[0]) + '">' + img + '<span class="glade-topup__name">' + esc(p.title) + '</span><span class="glade-topup__price">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
      });
      html += '</div>';
    }
    html += '<a class="glade-topup__more" href="/collections/accessories?sort_by=price-ascending">Browse socks, scarves &amp; accessories</a></div>';
    return html;
  }

  function run() {
    if (running) return;
    if (!holders().length) { clear(); return; }
    running = true;
    lastRun = Date.now();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gap = THRESHOLD - cart.total_price;
        if (!cart.item_count || gap <= 0) return null;
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.handle] = true; });
        var team = '';
        for (var k = 0; k < cart.items.length && !team; k++) team = teamFrom(cart.items[k].product_title);
        if (!team) return { list: [] };
        var tl = team.toLowerCase();
        return Promise.all([suggest(team + ' socks'), suggest(team + ' scarf'), suggest(team + ' shorts')]).then(function (res) {
          var seen = {}, out = [];
          [].concat(res[0], res[1], res[2]).forEach(function (p) {
            var price = Math.round(parseFloat(p.price) * 100);
            var handle = String(p.handle || '').toLowerCase();
            if (seen[handle] || inCart[handle]) return;
            if (String(p.title || '').toLowerCase().indexOf(tl) === -1) return;
            if (/your name/i.test(p.title || '')) return;
            if (price < gap || price > MAX_PRICE) return;
            seen[handle] = true;
            out.push(p);
          });
          out.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
          return { list: out.slice(0, 3) };
        });
      })
      .then(function (r) {
        clear();
        if (!r) return;
        styles();
        holders().forEach(function (h) { h.insertAdjacentHTML('afterend', render(r.list)); });
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 250); }
  document.addEventListener('DOMContentLoaded', soon);
  document.documentElement.addEventListener('cart:rerendered', soon);
  document.documentElement.addEventListener('product:added', function () { setTimeout(soon, 600); });
  if (document.readyState !== 'loading') soon();
  window.addEventListener('load', function () { setTimeout(soon, 800); });

  var mt;
  function watch() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      clearTimeout(mt);
      mt = setTimeout(function () {
        if (!running && missing() && Date.now() - lastRun > 1500) run();
      }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
})();